import 'slick-carousel'

// Home Page Carousel
const hero_carousel_arrow_button_prev = `<button type="button" class="slick-prev">
	<span class="icon"></span>
	<span class="screen-reader-text">Previous</span>
</button>`

const hero_carousel_arrow_button_next = `<button type="button" class="slick-next">
	<span class="icon"></span>
	<span class="screen-reader-text">Next</span>
</button>`

/*************** Slider ***************/
$('.hero-carousel')
	.slick({
		adaptiveHeight: true,
		arrows: true,
		autoplaySpeed: 6000,
		dots: true,
		infinite: true,
		slidesToShow: 1,
		speed: 500,
		autoplay: true,
		prevArrow: hero_carousel_arrow_button_prev,
		nextArrow: hero_carousel_arrow_button_next,
	})
	.fadeIn()

$('.slider').slick({
	infinite: true,
	dots: true,
	arrows: true,
	adaptiveHeight: true,
	autoplaySpeed: 4000,
	autoplay: true,
})

$('.banner').fadeIn()

$('.slide-gallery').slick({
	infinite: true,
	dots: true,
	arrows: true,
	adaptiveHeight: true,
})
